import React from 'react'
import './HoneypotField.scss'

export function HoneypotField({ label, name, form, field }) {
  return (
    <div className="seek-dailybreak">
      <label htmlFor={field.name} className="seek-dailybreak" />
      <input
        onChange={e => {
          form.setFieldValue(field.name, e.target.value)
        }}
        autoComplete="off"
        type="text"
        name={field.name}
        id={field.name}
        aria-hidden="true"
        tabIndex="-1"
      />
    </div>
  )
}
